import { Button, Box, InputLabel, Typography, styled } from '@mui/material';

export const ButtonIconStyle = styled(Button)({
    '&:hover': {
        border: 'none'
    },
    border: 'none',
    padding: '12px, 16px, 12px, 16px',
    fontSize: '14px',
    fontWeight: 500
});

export const LabelStyle = styled(InputLabel)(({ theme }) => ({
    '&:hover': {
        border: 'none'
    },
    border: 'none',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 500,
    color: theme.palette.primary.main,
    paddingBottom: '0px',
    cursor: 'pointer',
    marginRight: '5px',
    display: 'flex'
}));

export const StyledBox = styled(Box)(({ theme }) => ({
    height: '70%',
    overflowY: 'auto',
    marginTop: `2.5rem`,
    paddingBottom: `2rem`,
    paddingRight: '2.5rem',
    '::-webkit-scrollbar': {
        width: '0.75rem'
    },
    '::-webkit-scrollbar-track': {
        backgroundColor: '#E4DBF0',
        borderRadius: '0.625rem'
    },
    '::-webkit-scrollbar-button:vertical:start:decrement,::-webkit-scrollbar-button:vertical:end:increment': {
        display: 'none'
    },
    '::-webkit-scrollbar-thumb': {
        backgroundColor: '#7A49B9',
        borderRadius: '0.625rem'
    }
}));

export const Header = styled(Box)({
    height: '23px',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingRight: '3rem'
});

export const H3 = styled(Typography)({
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '24px',
    textAlign: 'left',
    marginLeft: '3.5rem'
});

export const CancelButtonStyle = styled(Button)(({ theme }) => ({
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    backgroundColor: `${theme.palette.background.paper} !important`,
    color: `${theme.palette.primary.main} !important`,
    boxShadow: 'none',
    border: '1px solid ',
    borderColor: theme.palette.primary.main
}));

export const ButtonStyle = styled(Button)(({ theme }) => ({
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 500,
    height: '44px',
    color: theme.palette.background.paper
}));

export const ButtonStyled = styled(Button)({
    height: '44px',
    width: '100px',
    fontSize: '12px'
});

export {};
